import { PublisherAutocompleteService } from './../../services/autocomplete/publisher-autocomplete.service';
import { PlaceAutocompleteService } from './../../services/autocomplete/place-autocomplete.service';
import { Field } from 'app/model/field.model';
import { Publisher } from 'app/model/publisher.model';
import { Connector } from 'app/utils/connector.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-editor-publisher',
  templateUrl: './editor-publisher.component.html',
  styleUrls: ['./editor-publisher.component.scss']
})
export class EditorPublisherComponent implements OnInit {
  @Input() field: Field;

  eventTypes: string[] = ['', 'publication', 'digitization', 'production'];

  constructor(private placeAutocompleteService: PlaceAutocompleteService,
    private publisherAutocompleteService: PublisherAutocompleteService) {
  }

  ngOnInit() {

  }

  /**
   * The button is for documents where the digitizer is missing - either the prefill did not
   * apply (older documents) or somebody removed/edited it. Once it is there, hide the button.
   * Only difmoe has a digitizing institution configured.
   */
  public showDigitizerButton(): boolean {
    return Connector.INSTANCE === 'difmoe' && !this.hasDigitizer();
  }

  private hasDigitizer(): boolean {
    return this.field.items.some((item) => (<Publisher> item).isDigitizationDefault());
  }

  /** Add a publisher prefilled with the digitizing institution (eventType=digitization). */
  public addDigitizer() {
    this.field.add();
    const publisher = <Publisher> this.field.items[this.field.count() - 1];
    publisher.fillDigitizationDefaults();
  }

}
